export const getDataTrackingParams = (
  dataTrackingParams?: string,
): Record<string, unknown> => {
  if (!dataTrackingParams) {
    return {};
  }

  try {
    return JSON.parse(dataTrackingParams);
  } catch (error) {
    return {};
  }
};

export const setDataTrackingParams = (
  dataTrackingParams: Record<string, unknown>,
): string => JSON.stringify(dataTrackingParams);
